document.addEventListener("DOMContentLoaded", function() {
    const estateUserFormDiv = document.querySelector(".estate-userForm");

    if (window.location.hash) {
        document.body.classList.add("formModal");
    }

    document.getElementById("EstateFormButton").addEventListener("click", function(e) {
        document.body.classList.add("formModal");
        e.stopPropagation();
    });

    document.addEventListener("click", function(e) {
        const swiperWrapper = document.querySelector(".estate-userForm");

        if (swiperWrapper && swiperWrapper.contains(e.target)) {
            if (!swiperWrapper.querySelector('.estate-user').contains(e.target)) {
                document.body.classList.remove("formModal");
            }
            e.stopPropagation();
        } else {
            document.body.classList.remove("formModal");
        }
    });

    estateUserFormDiv.addEventListener("click", function(e) {
        if (!e.target.closest('.estate-user')) {
            document.body.classList.remove("formModal");
        }
    });

    document.querySelector(".closeFormButton").addEventListener("click", function() {
        document.body.classList.remove("formModal");
    });
});